import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildFontsMenuItem(t: TranslateFn): NavItem {
  return {
    id: 'fonts',
    name: t('navigation.fonts.fonts'),
    link: '/fonts/',
    activePaths: ['/subscriptions/fonts/'],
    subMenuItems: [
      {
        id: 'fonts_sub',
        name: t('navigation.fonts.fonts'),
        link: '/fonts/',
        wrapItems: true,
        trending: {
          image:
            'https://www.creativefabrica.com/wp-content/uploads/2023/12/13/0474-Images-nav-menu-01_Font-section.png',
          imageLink: '/fonts/',
        },
        subMenuItems: [
          {
            name: t('navigation.fonts.script'),
            link: '/fonts/script-fonts/',
          },
          {
            name: t('navigation.fonts.display'),
            link: '/fonts/display-fonts/',
          },
          {
            name: t('navigation.fonts.sans_serif'),
            link: '/fonts/sans-serif-fonts/',
          },
          {
            name: t('navigation.fonts.serif'),
            link: '/fonts/serif-fonts/',
          },
          {
            name: t('navigation.fonts.blackletter'),
            link: '/fonts/blackletter-fonts/',
          },
          {
            name: t('navigation.fonts.slab_serif'),
            link: '/fonts/slab-serif-fonts/',
          },
          {
            name: t('navigation.fonts.decorative'),
            link: '/fonts/decorative-fonts/',
          },
          {
            name: t('navigation.fonts.dingbats'),
            link: '/fonts/dingbats-fonts/',
          },
          {
            name: t('navigation.fonts.color'),
            link: '/fonts/color-fonts/',
          },
          {
            name: t('navigation.fonts.discounted'),
            link: '/promotions/fonts/',
          },
          {
            name: t('navigation.fonts.view_all'),
            link: '/fonts/',
            isFootOption: true,
          },
        ],
      },
      {
        id: 'popular_styles',
        name: t('navigation.fonts.popular_styles'),
        wrapItems: true,
        subMenuItems: [
          {
            name: t('navigation.fonts.christmas'),
            link: '/fonts/christmas-fonts/',
          },
          {
            name: t('navigation.fonts.wedding'),
            link: '/fonts/wedding-fonts/',
          },
          {
            name: t('navigation.fonts.halloween'),
            link: '/fonts/halloween-fonts/',
          },
          {
            name: t('navigation.fonts.tattoo'),
            link: '/fonts/tattoo-fonts/',
          },
          {
            name: t('navigation.fonts.cricut'),
            link: '/fonts/cricut-fonts/',
          },
          {
            name: t('navigation.fonts.retro'),
            link: '/fonts/retro-fonts/',
          },
          {
            name: t('navigation.fonts.calligraphy'),
            link: '/fonts/calligraphy-fonts/',
          },
          {
            name: t('navigation.fonts.cursive'),
            link: '/fonts/cursive-fonts/',
          },
          {
            name: t('navigation.fonts.graffiti'),
            link: '/fonts/graffiti-fonts/',
          },
          {
            name: t('navigation.fonts.handwriting'),
            link: '/fonts/handwriting-fonts/',
          },
          {
            name: t('navigation.fonts.heart'),
            link: '/fonts/heart-fonts/',
          },
          {
            name: t('navigation.fonts.bubble'),
            link: '/fonts/bubble-fonts/',
          },
          {
            name: t('navigation.fonts.typewriter'),
            link: '/fonts/typewriter-fonts/',
          },
          {
            name: t('navigation.fonts.cute'),
            link: '/fonts/cute-fonts/',
          },
          {
            name: t('navigation.fonts.cool'),
            link: '/fonts/cool-fonts/',
          },
          {
            name: t('navigation.fonts.fancy'),
            link: '/fonts/fancy-fonts/',
          },
          {
            name: t('navigation.fonts.aesthetic'),
            link: '/fonts/aesthetic-fonts/',
          },
          {
            name: t('navigation.fonts.spooky'),
            link: '/fonts/spooky-fonts/',
          },
          {
            name: t('navigation.fonts.pixel'),
            link: '/fonts/pixel-fonts/',
          },
          {
            name: t('navigation.fonts.western'),
            link: '/fonts/western-fonts/',
          },
          {
            name: t('navigation.fonts.college'),
            link: '/fonts/college-fonts/',
          },
          {
            name: t('navigation.fonts.groovy'),
            link: '/fonts/groovy-fonts/',
          },
          {
            name: t('navigation.fonts.signature'),
            link: '/fonts/signature-fonts/',
          },
          {
            name: t('navigation.fonts.bold'),
            link: '/fonts/bold-fonts/',
          },
          {
            name: t('navigation.fonts.death_metal'),
            link: '/fonts/death-metal-fonts/',
          },
          {
            name: t('navigation.fonts.stencil'),
            link: '/fonts/stencil-fonts/',
          },
          {
            name: t('navigation.fonts.baseball'),
            link: '/fonts/baseball-fonts/',
          },
          {
            name: t('navigation.fonts.vintage'),
            link: '/fonts/vintage-fonts/',
          },
          {
            name: t('navigation.fonts.modern'),
            link: '/fonts/modern-fonts/',
          },
          {
            name: t('navigation.fonts.pretty'),
            link: '/fonts/pretty-fonts/',
          },
          {
            name: t('navigation.fonts.medieval'),
            link: '/fonts/medieval-fonts/',
          },
          {
            name: t('navigation.fonts.seventies'),
            link: '/fonts/70s-fonts/',
          },
          {
            name: t('navigation.fonts.military'),
            link: '/fonts/military-fonts/',
          },
          {
            name: t('navigation.fonts.space'),
            link: '/fonts/space-fonts/',
          },
          {
            name: t('navigation.fonts.eighties'),
            link: '/fonts/80s-fonts/',
          },
          {
            name: t('navigation.fonts.pirate'),
            link: '/fonts/pirate-fonts/',
          },
          {
            name: t('navigation.fonts.comic'),
            link: '/fonts/comic-fonts/',
          },
          {
            name: t('navigation.fonts.block'),
            link: '/fonts/block-fonts/',
          },
          {
            name: t('navigation.fonts.chicano'),
            link: '/fonts/chicano-fonts/',
          },
          {
            name: t('navigation.fonts.manga'),
            link: '/fonts/manga-fonts/',
          },
          {
            name: t('navigation.fonts.elegant'),
            link: '/fonts/elegant-fonts/',
          },
        ],
      },
      {
        id: 'text_tools',
        name: t('navigation.fonts.text_tools'),
        wrapItems: true,
        subMenuItems: [
          {
            name: t('navigation.webfont_generator'),
            link: '/webfont-generator/',
          },
          {
            name: t('navigation.tools.font_generator'),
            link: '/tools/font-generator/',
          },
          {
            name: t('navigation.fonts.wordcloud_generator'),
            link: '/shapecloud/',
          },
          {
            name: t('navigation.fonts.cursive_generator'),
            link: '/tools/cursive-font-generator/',
          },
          {
            name: t('navigation.fonts.small_text_generator'),
            link: '/tools/small-text-generator/',
          },
          {
            name: t('navigation.fonts.glitch_text_generator'),
            link: '/tools/glitch-text-generator/',
          },
          {
            name: t('navigation.fonts.cool_generator'),
            link: '/tools/cool-fonts-generator/',
          },
          {
            name: t('navigation.fonts.zalgo_text_generator'),
            link: '/tools/zalgo-text-generator/',
          },
          {
            name: t('navigation.fonts.instagram_font_generator'),
            link: '/tools/instagram-fonts-generator/',
          },
          {
            name: t('navigation.fonts.bold_text_generator'),
            link: '/tools/bold-text-generator/',
          },
          {
            name: t('navigation.fonts.wingdings_translator'),
            link: '/tools/wingdings-translator/',
          },
          {
            name: t('navigation.fonts.cursed_text_generator'),
            link: '/tools/cursed-text-generator/',
          },
          {
            name: t('navigation.fonts.italics_generator'),
            link: '/tools/italics-generator/',
          },
          {
            name: t('navigation.fonts.ascii_art_generator'),
            link: '/tools/ascii-art-generator/',
          },
          {
            name: t('navigation.fonts.caligraphy_text_generator'),
            link: '/tools/calligraphy-font-generator/',
          },
          {
            name: t('navigation.fonts.aesthetic_generator'),
            link: '/tools/aesthetic-fonts-generator/',
          },
          {
            name: t('navigation.fonts.cross_out_text_generator'),
            link: '/tools/strike-through-text-generator/',
          },
          {
            name: t('navigation.fonts.creepy_text_generator'),
            link: '/tools/creepy-text-generator/',
          },
          {
            name: t('navigation.fonts.gothic_generator'),
            link: '/tools/gothic-font-generator/',
          },
          {
            name: t('navigation.fonts.facebook_generator'),
            link: '/tools/facebook-fonts-generator/',
          },
          {
            name: t('navigation.fonts.bubble_generator'),
            link: '/tools/bubble-font-generator/',
          },
          {
            name: t('navigation.fonts.twitter_generator'),
            link: '/tools/twitter-fonts-generator/',
          },
          {
            name: t('navigation.fonts.discord_generator'),
            link: '/tools/discord-fonts-generator/',
          },
        ],
      },
    ],
  }
}
